<template>
    <div class="col-md-9">
        <div class="mian_right_box">
            <div class="row">
                <div class="col-md-12">
                </div>
            </div>
            <div class="clearfix"></div>
            <div class="sliderbox_main">
                <!-- Loading State -->
                <div v-if="franchiseStore.loading" class="loading-container">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-2">Loading franchise banners...</p>
                </div>
                
                <!-- Error State -->
                <div v-else-if="franchiseStore.error" class="error-container">
                    <div class="alert alert-warning" role="alert">
                        <h5>Unable to load franchise banners</h5>
                        <p>{{ franchiseStore.error }}</p>
                        <button @click="fetchFranchises" class="btn btn-primary btn-sm">Try Again</button>
                    </div>
                </div>
                
                <!-- Carousel -->
                <div v-else-if="slidesToShow.length > 0" id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                    
                    <div class="carousel-inner" role="listbox">
                        <div v-for="(slide, idx) in slidesToShow" 
                             :key="idx" 
                             :class="['item', { active: idx === 0 }]">
                            <a :href="slide.link" @click="handleSlideClick(slide)">
                                <img :src="slide.image"
                                     :alt="slide.alt || 'Slide'"
                                     style="height:var(--main-section-height);width:100%">
                            </a>
                        </div>
                    </div>
                    
                    <!-- Carousel Controls -->
                    <a class="left carousel-control" 
                       href="#carousel-example-generic" 
                       role="button"
                       data-slide="prev"
                       @click="prevSlide">
                        <span class="fa fa-chevron-left" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="right carousel-control" 
                       href="#carousel-example-generic" 
                       role="button"
                       data-slide="next"
                       @click="nextSlide">
                        <span class="fa fa-chevron-right" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
                
                <!-- No Slides State -->
                <div v-else class="no-slides-container">
                    <div class="alert alert-info" role="alert">
                        <h5>No franchise banners available</h5>
                        <p>Check back later for featured franchise opportunities.</p>
                    </div>
                </div>
            </div>
            <div>
            </div>
        </div>
        <br><br>
    </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useFranchiseStore } from '@/stores/franchiseStore'

const props = defineProps({
  slides: {
    type: Array,
    default: () => []
  }
})

const franchiseStore = useFranchiseStore()
const currentSlide = ref(0)
const carouselInstance = ref(null)

// Fetch franchises with banners
const fetchFranchises = async () => {
  try {
    await franchiseStore.fetchFranchises()
  } catch (err) {
  }
}

// Get franchises with banners from store
const franchisesWithBanners = computed(() => {
  if (!franchiseStore.franchises || !Array.isArray(franchiseStore.franchises)) {
    return []
  }
  
  return franchiseStore.franchises.filter(franchise => 
    franchise.banner && 
    franchise.is_active && 
    franchise.status === 'approved'
  )
})

// Transform franchises to slides format
const slidesToShow = computed(() => {
  if (props.slides && props.slides.length > 0) {
    return props.slides
  }
  
  return franchisesWithBanners.value.map(franchise => ({
    image: franchise.banner,
    link: `/franchise/${franchise.id}`,
    alt: franchise.business_name,
    title: franchise.business_name,
    category: franchise.category,
    investment: `?${parseInt(franchise.investment_min).toLocaleString()} - ?${parseInt(franchise.investment_max).toLocaleString()}`
  }))
})

// Handle slide click for navigation
const handleSlideClick = (slide) => {
  
  // The link will handle the navigation automatically
}

// Carousel control functions
const prevSlide = (event) => {
  event.preventDefault()
  if (carouselInstance.value) {
    carouselInstance.value.carousel('prev')
  } else if (typeof $ !== 'undefined' && $.fn.carousel) {
    $('#carousel-example-generic').carousel('prev')
  }
}

const nextSlide = (event) => {
  event.preventDefault()
  if (carouselInstance.value) {
    carouselInstance.value.carousel('next')
  } else if (typeof $ !== 'undefined' && $.fn.carousel) {
    $('#carousel-example-generic').carousel('next')
  }
}

// Initialize carousel when component mounts
onMounted(async () => {
  // Fetch franchises first
  await fetchFranchises()
  
  // Wait for DOM to be ready
  setTimeout(() => {
    // Initialize Bootstrap carousel
    if (typeof $ !== 'undefined' && $.fn.carousel) {
      carouselInstance.value = $('#carousel-example-generic')
      carouselInstance.value.carousel({
        interval: 5000, // Auto-slide every 5 seconds
        pause: 'hover', // Pause on hover
        wrap: true, // Continuous loop
        keyboard: true // Enable keyboard navigation
      })
      
      // Update current slide index on slide change
      carouselInstance.value.on('slid.bs.carousel', function (e) {
        currentSlide.value = $(e.target).find('.active').index()
      })
      

    }
  }, 100)
})
</script>

<style scoped>
.mian_right_box, .sliderbox_main, .carousel-inner {
  height: 350px;
  min-height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.carousel-inner {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.carousel-inner img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.carousel-inner img:hover {
  transform: scale(1.02);
}

.carousel-control.left {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.8);
    text-align: center;
    top: 50%;
    margin-top: -25px;
    left: 15px;
    line-height: 46px;
    text-shadow: none;
    opacity: 0.9;
    background: rgba(0, 0, 0, 0.6);
    padding: 0px;
    transition: all 0.3s ease;
    cursor: pointer;
    z-index: 10;
}

.carousel-control.right {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 2px solid rgba(255, 255, 255, 0.8);
    text-align: center;
    top: 50%;
    margin-top: -25px;
    right: 15px;
    line-height: 46px;
    text-shadow: none;
    opacity: 0.9;
    background: rgba(0, 0, 0, 0.6);
    padding: 0px;
    transition: all 0.3s ease;
    cursor: pointer;
    z-index: 10;
}

.carousel-control:hover {
    opacity: 1 !important;
    background: rgba(0, 0, 0, 0.8) !important;
    border-color: #ff6b35;
    transform: scale(1.1);
}

.carousel-control .fa {
    color: white;
    font-size: 18px;
    font-weight: bold;
}





/* Tablet Responsive */
@media (max-width: 1024px) {
    .mian_right_box, .sliderbox_main, .carousel-inner {
        height: 300px;
        min-height: 300px;
    }
    
    .carousel-control.left {
        left: 10px;
        height: 45px;
        width: 45px;
        line-height: 41px;
    }
    
    .carousel-control.right {
        right: 10px;
        height: 45px;
        width: 45px;
        line-height: 41px;
    }
}

/* Mobile Responsive */
@media (max-width: 768px) {
    .mian_right_box, .sliderbox_main, .carousel-inner {
        height: 250px;
        min-height: 250px;
    }
    
    .carousel-control.left {
        left: 8px;
        height: 40px;
        width: 40px;
        line-height: 36px;
    }
    
    .carousel-control.right {
        right: 8px;
        height: 40px;
        width: 40px;
        line-height: 36px;
    }
    
    .carousel-control .fa {
        font-size: 16px;
    }
    

    

}

/* Small Mobile Responsive */
@media (max-width: 480px) {
    .mian_right_box, .sliderbox_main, .carousel-inner {
        height: 200px;
        min-height: 200px;
    }
    
    .carousel-control.left {
        left: 5px;
        height: 35px;
        width: 35px;
        line-height: 31px;
    }
    
    .carousel-control.right {
        right: 5px;
        height: 35px;
        width: 35px;
        line-height: 31px;
    }
    
    .carousel-control .fa {
        font-size: 14px;
    }
    

    

}

/* Landscape Mobile */
@media (max-width: 768px) and (orientation: landscape) {
    .mian_right_box, .sliderbox_main, .carousel-inner {
        height: 180px;
        min-height: 180px;
    }
}

/* Touch Device Optimizations */
@media (hover: none) and (pointer: coarse) {
    .carousel-control {
        opacity: 1 !important;
        background: rgba(0, 0, 0, 0.7) !important;
    }
    
    .carousel-control:hover {
        transform: none;
    }
}

/* High DPI Displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .carousel-inner img {
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
    }
}

/* Smooth Animations */
.carousel-inner .item {
    transition: transform 0.6s ease-in-out;
}

.carousel-inner .item.active {
    transform: translateX(0);
}

.carousel-inner .item.next {
    transform: translateX(100%);
}

.carousel-inner .item.prev {
    transform: translateX(-100%);
}

/* Accessibility Improvements */
.carousel-control:focus {
    outline: 2px solid #ff6b35;
    outline-offset: 2px;
}





/* Loading State */
.carousel-inner img {
    opacity: 0;
    animation: fadeIn 0.5s ease-in forwards;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* Loading Container */
.loading-container {
    height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border-radius: 8px;
    color: #6c757d;
}

.error-container,
.no-slides-container {
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8f9fa;
    border-radius: 8px;
}

/* Make entire slide clickable */
.carousel-inner .item a {
    display: block;
    height: 100%;
    width: 100%;
    position: relative;
    cursor: pointer;
    text-decoration: none;
}

.carousel-inner .item a:hover {
    text-decoration: none;
}



.owl-item .img-ver img.img-responsive {
    height: 124px;
}

.logolistmain {
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 5px rgba(0, 0, 0, .2);
    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, .2);
    -moz-box-shadow: 0 0 5px rgba(0, 0, 0, .2);
    text-align: center;
    position: relative;
    margin: 10px;
    min-height: 260px;
}

.tbo-info3 {
    background: none;
    position: static;
    bottom: 100%;
    left: 0;
    height: 100%;
    width: 100%;
    font-size: 12px;
    line-height: 17px;
    padding: 6px;
    color: #333;
    text-align: left;
    overflow: hidden;
    transition: all .3s ease;
    opacity: 1;
}

.tbo-info2 {
    background: none;
    position: static;
    bottom: 100%;
    left: 0;
    height: 100%;
    width: 100%;
    font-size: 12px;
    line-height: 17px;
    padding: 6px;
    color: #333;
    text-align: left;
    overflow: hidden;
    transition: all .3s ease;
    opacity: 1;
}

.owl-item .img-ver img.img-responsive {
    height: auto !important;
    max-height: 124px;
}

.itfornewimgbox {
    min-height: 124px;
}

.img-ver {
    background: none !important;
}

.owl-item .newlinebox {
    margin: 10px;
}
</style> 